import "./css/master.css";
import { useLocation } from "react-router-dom";

function Footer() {

    const { pathname } = useLocation();

    let isInquiryStatus = ['/relation_inquiry_create'].includes(pathname) ? true : false;
    const handleScrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }
    function ShowFloatingButton() {
        if (isInquiryStatus) {
            return (
                <span onClick={handleScrollToTop} style={{ position: "fixed", cursor: "pointer" }}>ページの先頭へ戻る</span>
            )
        } else {
            return (
                <span onClick={handleScrollToTop} style={{ cursor: "pointer" }}>ページの先頭へ戻る</span>
            )
        }
    }

    return (
        <div>
            <footer className="site-footer of-special">
                <div className="seg-primary">
                    <div className="str-outer-full">
                        <div className="str-inner">
                            <p className="scroll-top js-page-top is-active is-visible"><ShowFloatingButton /></p>
                        </div>
                    </div>
                </div>
                <div className="seg-secondary">
                    <div className="str-outer-wide">
                        <div className="str-inner">
                            <div className="wrap">
                                <p className="copyright"><small>Copyright &#169; NEC Corporation 2023-2026. All
                                    rights reserved.</small></p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default Footer;